import React, { useState, useEffect, useRef } from 'react';

// material ui
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormGroup from '@material-ui/core/FormGroup';
import Checkbox from '@material-ui/core/Checkbox';

import useStyles from './styles';

import chunk from 'lodash/chunk';

import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import ChevronRight from '@material-ui/icons/ChevronRight';
import ChevronLeft from '@material-ui/icons/ChevronLeft';

function SubFormCheckbox2({ id, setValue, saveValue, saveChangeValue, value, form, keluarga, pk, navigationMode, handleNextSub, handleBackSub, subformIndex, isSubmitting }) {

    const nextRef = useRef(null);
    const backRef = useRef(null);

    const classes = useStyles();
    const [error, setError] = useState({});

    const [show, setShow] = useState(false);

    const [jawaban, setJawaban] = useState(value.jawaban || '')
    const [kondisi, setKondisi] = useState(value.kondisi || 0)

    useEffect(() => {
        setError({})
    }, [])

    console.log("checkbox2")

    const { pertanyaan } = form;

    useEffect(() => {

        let normalizeValue = {
            Pertanyaan: pertanyaan,
            Jawab_Pilih: jawaban,
            Jawaban_H1: value.kondisi || 0,
            Jawaban_H2: 0,
            No_Pertanyaan: parseInt(form.no),
        }
        if (value._rev) {
            normalizeValue._rev = value._rev
        }
        if (show) {
            saveChangeValue(normalizeValue)
        }

        //console.log("save onchange => ", normalizeValue)

    }, [jawaban, kondisi])

    useEffect(() => {
        //console.log('validation called');
        if (form.show_if?.length <= 0) {
            setShow(true);
        } else {

            const cekShow = form.show_if.some(show_if => {
                return pk[show_if.no]?.jawaban === show_if.value;
            });


            setShow(cekShow);
            if (!cekShow) {
                if (navigationMode === 'back') {
                    handleBackSub();
                } else {
                    handleNextSub()
                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id, form])

    if (!show) {
        return null;
    }


    const handleChangeCheckbox = option_no => (e) => {
        const selected = value.jawaban || []
        const selectedIndex = selected.indexOf(option_no);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, option_no);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }

        setValue({ target: { name: "jawaban", value: newSelected } })

        setJawaban(newSelected)

        setError({
            ...error,
            jawaban: ""
        })

        // setSomethingChange(true)
    }

    const isChecked = option_no => {
        const selected = value.jawaban || [];
        return selected.indexOf(option_no) !== -1;
    }

    const validate = () => {
        let newError = {};

        if (!value.jawaban) {
            newError.jawaban = "Wajib diisi";
        } else if (value.jawaban?.length <= 0) {
            newError.jawaban = "Wajib diisi"
        }

        if (form.kondisi) {
            if (typeof value.kondisi === "undefined") {
                newError.kondisi = "Kondisi wajib diisi";
            }
        }

        return newError;
    }

    const handleSubmit = (e) => {

        console.log("Handle Submit checkbox2");
        e.preventDefault()
        const findErrors = validate();

        const errorValues = Object.values(findErrors);

        if (errorValues.length > 0 && errorValues.some(err => err !== '')) {
            setError(findErrors);
        } else {

            // const normalizeValue = {
            //     pertanyaan,
            //     jawaban_1: value.jawaban,
            //     jawaban_2: value.jawaban_lainnya

            // }

            let normalizeValue = {
                Pertanyaan: pertanyaan,
                Jawab_Pilih: value.jawaban,
                Jawaban_H1: value.kondisi || 0,
                Jawaban_H2: 0,
                No_Pertanyaan: parseInt(form.no),
            }
            if (value._rev) {
                normalizeValue._rev = value._rev
            }
            saveValue(normalizeValue)
        }
    }
    //console.log('here')
    const chunk_options_keys = chunk(Object.keys(form.options), form.options_chunk);


    return (
    <>
    <form id={id} onSubmit={handleSubmit} noValidate>
        <div className={classes.card}>
            <div className={classes.cardHeader}>
                <Typography margin="normal" paragraph>
                    <span className={classes.badge}>{form.no}</span>{pertanyaan}</Typography>
            </div>
            <div className={classes.cardBody}>
                <Grid container spacing={1}>
                    <Grid item xs={12} >
                        <FormControl error={error.jawaban ? true : false} component="fieldset">
                            <FormGroup className={classes.radioGroup}>
                                {
                                    chunk_options_keys.map((keys_group, index) => {

                                        return (<div key={index} className={classes.radioSection}>
                                            {
                                                keys_group.map(key => {
                                                    const intKey = parseInt(key);
                                                    const nomor = parseInt(key)+1;
                                                    return <FormControlLabel
                                                        key={key}
                                                        control={<Checkbox checked={isChecked(intKey + 1)} onChange={handleChangeCheckbox(intKey + 1)} value={intKey + 1} />}

                                                        label={`${nomor}. ${form.options[key]}`} />
                                                })
                                            }
                                        </div>)
                                    })
                                }
                            </FormGroup>
                            <FormHelperText>{error.jawaban}</FormHelperText>
                        </FormControl>
                    </Grid>

                </Grid>
            </div>
        </div>
    </form>

    <Grid item xs style={{marginTop:20}}>
        <Button
            ref={backRef}
            // disabled={!isSomethingChange || isSubmitting}
            onClick={handleBackSub}><ChevronLeft className={classes.iconLeft} /> Sebelumnya </Button>

        {isSubmitting && <CircularProgress size={14} />}
        <Button
            style={{float: 'right'}}
            ref={nextRef}
            form={id}
            disabled={isSubmitting}
            type="submit">{(subformIndex >= 31 || (subformIndex === 30 && pk["0231"] && pk["0231"].jawaban === "2")) ? 'Selanjutnya' : 'Selanjutnya'} <ChevronRight className={classes.iconRight} /></Button>
    </Grid>
    </>
    )
}

export default SubFormCheckbox2;